<template>
  <div class="module-section-container">
    <div class="header">
      <div :class="['left-cont', descSide ? 'desc-side' : '']">
        <h2 class="title">{{ $t(title) }}</h2>
        <p
          class="desc"
          v-if="desc">
          {{ $t(desc) }}
          <el-tooltip
            popper-class="module-tooltip"
            effect="light"
            :offset="220"
            v-if="tips">
            <span class="tooltips"></span>
            <template #content>
              {{ $t(tips) }}
            </template>
          </el-tooltip>
        </p>
      </div>
      <slot
        class="right-cont"
        name="right-cont"/>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ModuleSection',
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: ''
    },
    descSide: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="less">
.module-section-container {
  padding: 40px;
  .header {
    padding-bottom: 40px;
    .title {
      color: #131523;
      font-size: 20px;
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC !important;
    }
    .desc {
      margin-top: 20px;
      display: flex;
      align-items: center;
      // width: 462px;
      font-size: 14px;
      font-weight: 300;
      color: #a1a7c4;
      line-height: 14px;
      .tooltips {
        margin-left: 10px;
        display: inline-block;
        width: 20px;
        height: 20px;
        background-image: url(~assets/image/icons/icon_tooltip.png);
        background-repeat: no-repeat;
        background-size: cover;
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.module-section-container {
  min-height: 712px;
  padding: 40px;
  .header {
    display: flex;
    justify-content: space-between;
    .desc-side {
      display: flex;
      align-items: center;
      .desc {
        margin-top: 0;
        margin-left: 10px;
      }
    }
  }
}

</style>
<style lang="less">
.module-tooltip {
  width: 600px;
  font-size: 14px;
  color: #5a607f;
  line-height: 28px;
  white-space: pre-wrap;
  box-shadow: 0px 6px 20px 0px rgba(51, 55, 82, 0.1);
  padding: 41px 30px 32px 30px;
  box-sizing: border-box;
  .popper__arrow {
    color: #ffffff;
    border: none;
  }
}
.module-tooltip.is-light {
  border: none;
}
</style>
